
(function () {
  if (window.__simpleAddIconInit) return;
  window.__simpleAddIconInit = true;
 
  function addToCart(btn) {
    if (btn.tagName === 'A') {
      // Multi-variant: navigate to the product page to pick options.
      window.location.href = btn.getAttribute('href');
      return;
    }
 
    if (btn.disabled || btn.classList.contains('js-loading')) return;
 
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
 
    btn.classList.add('js-loading');
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        btn.classList.remove('js-loading');
 
        if (!result.ok) {
          console.error('Add to cart failed:', result.data && result.data.description);
          return;
        }
 
        btn.classList.add('js-added');
        setTimeout(function () {
          btn.classList.remove('js-added');
        }, 1500);
 
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
              var span = bubble.querySelector('span');
              if (span) span.textContent = cart.item_count;
            });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          })
          .catch(function () {});
      })
      .catch(function (err) {
        btn.classList.remove('js-loading');
        console.error('Add to cart request failed:', err);
      });
  }
 
  // Capture phase on document: this fires BEFORE the event reaches whatever
  // element the browser thinks is "on top" (e.g. a whole-card overlay link),
  // and BEFORE that element's own default navigation happens. We detect a
  // click on our icon by screen position, not by DOM target, so it works
  // regardless of any unknown overlay sitting visually above it.
  document.addEventListener(
    'click',
    function (e) {
      var wrappers = document.querySelectorAll('.card__quick-add-icon-wrapper');
      for (var i = 0; i < wrappers.length; i++) {
        var rect = wrappers[i].getBoundingClientRect();
        if (
          e.clientX >= rect.left &&
          e.clientX <= rect.right &&
          e.clientY >= rect.top &&
          e.clientY <= rect.bottom
        ) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
 
          var btn = wrappers[i].querySelector('.js-simple-add-icon');
          if (btn) addToCart(btn);
          return;
        }
      }
    },
    true
  );
})();